<template>

    <Head :title="__('Reset Password')" />
    <div class="flex align-items-center justify-content-center min-h-screen p-3">
        <v-form name="formReset"
                class="w-full"
                style="max-width:26rem"
                @keyup.enter="update">
            <Card>
                <template #header>
                    <div class="flex justify-content-center pt-4">
                        <Image :src="systemLogo"
                               width="140" />
                    </div>
                </template>

                <template #content>
                    <Message v-if="props.rules"
                             severity="info"
                             :closable="false"
                             class="mb-4">
                        <ul class="pl-3 m-0">
                            <li v-for="(rule, index) in props.rules"
                                :key="index">
                                {{ rule }}
                            </li>
                        </ul>
                    </Message>

                    <div class="flex flex-column gap-2 mb-3">
                        <label for="email">{{ __('E-Mail Address') }}</label>
                        <InputText type="text"
                                   id="email"
                                   size="small"
                                   class="w-full"
                                   @input="inputNewData"
                                   :invalid="!!form.errors.email"
                                   v-model="form.email" />
                        <small v-if="form.errors.email"
                               class="p-error">{{ __(form.errors.email) }}</small>
                    </div>

                    <div class="flex flex-column gap-2 mb-3">
                        <label for="password">{{ __('Password') }}</label>
                        <Password inputId="password"
                                  size="small"
                                  class="w-full"
                                  inputClass="w-full"
                                  :feedback="false"
                                  toggleMask
                                  :invalid="!!form.errors.password"
                                  @input="form.errors.password = null"
                                  v-model="form.password" />
                        <small v-if="form.errors.password"
                               class="p-error">{{ __(form.errors.password) }}</small>
                    </div>

                    <div class="flex flex-column gap-2 mb-4">
                        <label for="password_confirmation">{{ __('Confirm password') }}</label>
                        <Password inputId="password_confirmation"
                                  size="small"
                                  class="w-full"
                                  inputClass="w-full"
                                  :feedback="false"
                                  toggleMask
                                  v-model="form.password_confirmation" />
                    </div>

                    <Button @click="update"
                            :label="__('Reset password')"
                            icon="pi pi-sign-in"
                            class="w-full" />

                    <div class="text-center mt-3">
                        <Link :href="route('app-login')"
                              :aria-hidden="false"
                              v-if="route().has('app-login')">
                            <i class="pi pi-star mr-2"></i>{{ __('Login') }}
                        </Link>
                    </div>
                    <input type="hidden"
                           id="token"
                           name="token"
                           v-model="form.token" />
                </template>
            </Card>
        </v-form>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { Head } from '@inertiajs/vue3'
import { Link } from '@inertiajs/vue3'

import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Card from 'primevue/card';
import Message from 'primevue/message';

import Layout from '@layouts/LayoutNoMenuNoFooter.vue'
import Image from '@helper/Image.vue'
import { __ } from '@helper/utils.js'
import { systemLogo, startSplash } from '@helper/constants.js'

defineOptions({ layout: Layout })

const props = defineProps({
    token: String,
    email: String,
    rules: Object,
})

// -----------------------------------------------------

const success = ref(false)
const form = useForm({ email: props.email, password: '', password_confirmation: '', token: props.token })

// -----------------------------------------------------

const inputNewData = () => {
    form.errors.email = null
    success.value = false
}

// -----------------------------------------------------

const update = () => {
    form.post(route('password.update'), {
        onSuccess: () => {
            success.value = true
            form.email = ''
        },
        onError: (err) => {
            console.error(err)
        },
    })
}

// -----------------------------------------------------
</script>

<style lang="scss" scoped></style>
